export const getDisplayForCtaType = type =>
  ({
    ABOUT: 'Learn More',
    GIFTING: 'Request Gifting',
    CODES: 'Request Discount Code',
    COLLABS: 'Propose Collaborations',
    CHAT: 'Chat With Them',
    URL: 'Visit Webpage'
  }[type]);
